module.exports = __webpack_public_path__ + "img/q3-8.c6cafdca.png";